/* mobile menu */
function mobile_menu()
{
	$('.mobile.fa-bars').on('click', function(e) {
		e.preventDefault();

		$('.mobile.fa-bars, .mobile.nav').toggleClass('active');
	});
}

/* cart discount */
function cart_discount()
{
	$('#content .tfoot .note label[for="discount"]').on('click', function(e) {
		e.preventDefault();

		$('#content .tfoot .note label[for="discount"]').toggleClass('hide');
		$('#content .tfoot .note #discount').toggleClass('show');
	});
}

/* account */
function account()
{
	$('form[action*="/account/recover"]').hide();
	
	$('.forgot-password-show').on('click', function(e) {
		e.preventDefault();

		$('#customer_login').hide();
		$('form[action*="/account/recover"]').show();
	});

	$('.forgot-password-hide').on('click', function(e) {
		e.preventDefault();

		$('#customer_login').show();
		$('form[action*="/account/recover"]').hide();
	});

	if(window.location.hash == '#recover') { $('.forgot-password-show').trigger('click'); }
}

/* ready */
$(function()
{
	mobile_menu();
	cart_discount();
	account();
});